<script lang="ts" setup>
type Props = { isActive: boolean }

defineProps<Props>()
</script>

<template>
  <div class="header-widgets">
    <header-widget-auth />

    <header-widget-basket v-if="isActive" />
  </div>
</template>

<style lang="scss" scoped>
.header-widgets {
  display: flex;
  gap: 12px;
  align-items: center;

  @include media('>=desktop') {
    gap: 24px;
  }
}
</style>
